import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import {TableViewHeading} from "../table-view-heading.tsx";

interface Props {
    /**
     * The title to display in the table view
     */
    tableTitle?: string;
    /**
     * Node which shows up aside from the title in the table view
     */
    tableBannerNode?: React.ReactNode;
    /**
     * Whether filters should be shown
     */
    shouldShowFilters: boolean;
}

/**
 * Renders the table view heading if title/banner text is provided and filters should be shown.
 */
const GuideTranscriptsTableViewHeading = ({
    tableTitle,
    tableBannerNode,
    shouldShowFilters,
}: Props): React.ReactNode => {
    if (!(tableTitle || tableBannerNode) || !shouldShowFilters) {
        return null;
    }

    return (
        <View style={{marginBlockEnd: spacing.large_24}}>
            <TableViewHeading
                title={tableTitle}
                subtitle={tableBannerNode}
                subtitleAlign={
                    !tableTitle && tableBannerNode ? "start" : undefined
                }
            />
        </View>
    );
};

export {GuideTranscriptsTableViewHeading};
